import { render, staticRenderFns } from "./BorderCollapse.vue?vue&type=template&id=0d1e0b2c&"
import script from "./BorderCollapse.vue?vue&type=script&lang=js&"
export * from "./BorderCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports